/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76210ResListItemOtherDataObjDataObj {
  
  /** 数据类型：text|image|video|voice|file */
  dataType?: string;
  
  /** 文件名称 */
  fileName?: string;
  
  /** 文件地址 */
  fileUrl?: string;
  
  /** 文件大小 */
  fileSize?: string;
  
  /** 操作人ID */
  operatorId?: string;
  
  /** 操作人昵称 */
  operatorName?: string;
  
};
    
  
    
export interface IAPI76210ResListItemOtherDataObj {
  
  /** 消息类型：annex_file:附件 */
  messageType?: string;
  
  /** 消息详情 ,OtherDataInfo */
  data?: IAPI76210ResListItemOtherDataObjDataObj;
  
};
    
  
    
export interface IAPI76210ResListItemSenderObj {
  
  /** 成员Id */
  userId?: string;
  
  /** 成员名称 */
  userName?: string;
  
  /** 成员头像 */
  userHeadUrl?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 是否逾期 */
  isOverdue?: number;
  
};
    
  
    
export interface IAPI76210ResListItem {
  
  /** 消息唯一ID */
  messageId?: string;
  
  /** 文本内容 */
  content?: string;
  
  /** 发送时间 */
  sendTime?: string;
  
  /** 扩展信息 ,OtherData */
  otherData?: IAPI76210ResListItemOtherDataObj;
  
  /** 发送人信息 ,SendUserResult */
  sender?: IAPI76210ResListItemSenderObj;
  
};
    
  



export interface API76210Req {
  
  /** 业务ID */
  bizNo?: string;
    
  /** 检索内容 */
  queryContent?: string;
    
  /** 数据类型，file|image_video */
  dataType?: string;
    
  /** 开始日期 */
  startDate?: string;
    
  /** 结束日期 */
  endDate?: string;
    
  /** 每几页 */
  pageIndex?: string;
    
  /** 每页尺寸 */
  pageSize?: string;
    
};



export interface API76210Res {
  /** T  */
  list?: IAPI76210ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 76210 分页查询聊天记录（右边）

export interface IUseGetAPI76210Return {
  /** 分页查询聊天记录（右边）: 接口请求状态 */
  isAPI76210Loading: boolean;
  /** 分页查询聊天记录（右边）: 接口请求返回数据 */
  dataAPI76210: API76210Res;
  /**  分页查询聊天记录（右边）: 接口数据请求方法 */
  fetchAPI76210Data: (inputs: API76210Req, config?: YWRequestConfig) => Promise<API76210Res>;
  /** 分页查询聊天记录（右边）: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76210 = ():IUseGetAPI76210Return => {
  let isMount = true;
  const [isAPI76210Loading, setIsAPI76210Loading] = useState(false);
  const [dataAPI76210, setDataAPI76210] = useState<API76210Res>({} as API76210Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/message/search`;

  const fetchAPI76210Data = async (inputs: API76210Req, config?: YWRequestConfig): Promise<API76210Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76210Req>) || {}) as API76210Req;
    
  
    if ( isMount ) {
      setIsAPI76210Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76210Res>(`${basePath}/yoaichat-web/chat/message/search?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76210(res || {} as API76210Res);
        setIsAPI76210Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76210Loading(false);
      }
      return false as unknown as API76210Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76210Loading,
    dataAPI76210,
    fetchAPI76210Data,
    requestUrl,
  }
}

